import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const CashCropCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/CashCropEditor')
  const { t: cropT } = useTranslation('@cibo/ui/cropNames')
  const detail = params.row.findDetail({ traitId, year })

  const { plantedAt, harvestedAt, preventPlant, crop } = detail?.input || {}

  if (crop || preventPlant) {
    return (
      <Stack>
        {preventPlant ? (
          <>
            <Typography variant="body1">{t('preventedPlanting')}</Typography>
            <Typography variant="caption">{cropT(crop)}</Typography>
          </>
        ) : (
          <Typography variant="body1">{cropT(crop)}</Typography>
        )}
        {!!plantedAt && !!harvestedAt && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t('date', { date: new Date(plantedAt) })} -{' '}
            {t('date', { date: new Date(harvestedAt) })}
          </Typography>
        )}
      </Stack>
    )
  }

  return <Typography>{cropT(detail?.result)}</Typography>
}
